import { redirectFromSettings, type RedirectFromSettingsArgs } from "@client/content/modules/actions";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { DEFAULT_VALUE } from "../../ending/selectors";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {
  formId: string;
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();
  const endingsValueSelector = getSettingValueSelector(TargetSelector.Entity, "endings");

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    const detail = localState.detail[props.formId];
    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      detail: detail.form!,
      email: localState.email,
      emailFieldId: localState.emailFieldId,
      endingDefaults: DEFAULT_VALUE,
      endingsValue: endingsValueSelector(state, props),
      status: detail.status,
      error: detail.error
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  redirect: (args: RedirectFromSettingsArgs) => dispatch(redirectFromSettings(args))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
